<template>
    <b-badge class="attestation-badge" :variant="badgeVariant">
        {{ statusLabel }}
    </b-badge>
</template>

<script>
export default {
    name: 'AttestationBadge',
    props: {
        equipment: Object
    },
    computed: {
        statusLabel () {
            const status = this.equipment.attestationStatus
            if (status === 'ATTESTED') {
                return 'Attested'
            } else if (status === 'UPDATED') {
                return 'Non-attested'
            } else if (status === 'INCOMPLETE') {
                return 'Incomplete'
            } else {
                return '' // shouldn't happen
            }
        },
        badgeVariant () {
            const status = this.equipment.attestationStatus
            if (status === 'ATTESTED') {
                if (this.noEFN && !this.hasNARegistration) {
                    return 'warning'
                } else {
                    return 'success'
                }
            } else if (status === 'UPDATED') {
                return 'warning'
            } else if (status === 'INCOMPLETE') {
                return 'danger'
            } else {
                return '' // shouldn't happen
            }
        },
        noEFN () {
          return this.equipment.engine_family_name === null || this.equipment.engine_family_name.includes('[No match found]')
        },
        hasNARegistration() {
          return this.equipment.registration?.tag_type === 'NA'
        }
    }
}
</script>

<style lang="scss">

</style>
